import  React,{Component} from 'react';
import axios from 'axios'; 
import Serverurl from './Apiurl';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import TableBody from '@mui/material/TableBody';
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table'; 
import TableContainer from '@mui/material/TableContainer';  
import TableRow from '@mui/material/TableRow';  
import TableHead from '@mui/material/TableHead';  
import TableCell from '@mui/material/TableCell'; 
import TableSortLabel from '@mui/material/TableSortLabel'; 
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';  
import { styled } from '@mui/styles'; 
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { NavLink,Navigate  } from 'react-router-dom';
import Radio from '@mui/material/Radio';
import SearchIcon from '@mui/icons-material/Search';
const MMCbranchid=0;

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


const headCells = [



]

function EnhancedTableHead(props) {
  const {  order, orderBy,   onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };
  
  
return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));


const EnhancedTableToolbar = props => {
const classes = useToolbarStyles();
const { numSelected } = props;

  
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = styled(theme =>({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
 
form: {
    width: '500%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  
})
)
export default  class Teachersubject extends Component{ 

	constructor(props){
	super(props)
		this.state={
			Brancharr:[],Classarr:[],subarra:[],classid:0,teacherarr:[],subid:0,AssignmentData:[],branchid:0,submitbtn:'Save',
			redirect:false,btndisabled:false,errormessage:'',erropen:false,errortype:'error',teacherdata:[],ts_ur_id:0,ts_sb_id:'',sylabus:0,allchecked:false,Batcharr:[],
			batchid:0,assignarray:[],asid:0,
		}
		
		
		
	}
	
	componentWillMount() {
		localStorage.setItem("pageactive",14)
		document.title = "MM Coching Center - Bulk Attendance";
this.ClassBind()
	}
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;

  this.setState({ [nam]: val }, () => {
   
   
   if(this.state.sylabus!==0 ){
	   
	   
	   this.SubjectBind();
	   
	   
   }
    if(this.state.subid!==0 ){
	   
	   
	   this.BatchBind();
	   
	   
   }
   
       if(this.state.batchid!==0 && this.state.sylabus!==0){
	   
	   
	   this.AssignmentBind();
	   
	   
   }
   
  });
}


ClassBind()
{
	axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Classarr:resp.data	
							}) 
			}
	
	
	   }) .then(data => {
        let classFromApi = this.state.Classarr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Classarr: [{value: '0', display: 'Select Class'}].concat(classFromApi)
        });
      })  
	 

}
SubjectBind()
{

	axios.get(Serverurl+'ajaxsubjects.php?action=getall&sb_class_id='+this.state.classid+'&sb_syllabustype='+this.state.sylabus)
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						subarra:resp.data	
							}) 
			}
	
	
	   }) .then(data => {
        let classFromApi = this.state.subarra.map(row => {
                          
          return {value: row.sb_id, display:row.sb_title}
        });
      
		
        this.setState({
          subarra: [{value: '0', display: 'Select Class'}].concat(classFromApi)
        });
      })
	 
	 
	  
}

BatchBind()
{
	axios.get(Serverurl+'ajaxbatch.php?action=list&bc_class_id='+this.state.classid+'&bc_syllabustype='+this.state.sylabus+'&bc_br_id='+localStorage.getItem("MMCbranchid"))
        .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Batcharr:resp.data	
							}) 
			}else{
				
				this.setState({
						Batcharr:[]	
							}) 
			}

	   }).then(data => {
        let batchFromApi = this.state.Batcharr.map(row => {
                          
          return {value: row.bc_id, display:row.bc_title}
        });
      
		
        this.setState({
          Batcharr: [{value: '0', display: 'Select Batch'}].concat(batchFromApi)
        });
      })

}



/*
GetBatchByclassAndBatch(){
    let branchid = 0; 
    if (localStorage.getItem('MMCrole') !== "1") {
        branchid = localStorage.getItem('MMCbranchid');
    } else {
        branchid = this.state.branchid;
    }

	
  axios.get(
    Serverurl + 'ajaxteachersubject.php?action=getall'+'&bc_class_id=' + this.state.classid +'&bc_br_id=' + branchid +'&ts_sb_id='+this.state.subid+'&ts_ur_id='+this.state.ts_ur_id
  )
  .then(resp => {  
		  const totalcount=resp.data.length;
		  
		   const selectedCount = resp.data.filter(item => item.isseleceted === "1").length;

	if(selectedCount===totalcount){
		this.setState({  
			  allchecked:true,  
			
			})
			
	}
	else{
		
		this.setState({  
			  allchecked:false,  
			
			})	
	}
    if(resp.data.length>0){
		
			this.setState({  
			  AssignmentData: resp.data,  
			
			});
     }
	 else{
		   this.setState({AssignmentData:[],});
	 }
   
    });

}
*/


GetAssignmentList(){


	
  axios.get(
    Serverurl + 'ajaxassignment.php?action=getassignmentlist&classid='+this.state.classid+'&batchid='+this.state.batchid+'&subjectid='+this.state.subid+'&as_id='
	+this.state.asid+'&branchid='+localStorage.getItem('MMCbranchid')+'&yearid='+localStorage.getItem('MMCyearid') )
  .then(resp => {  

    if(resp.data.length>0){
		
			this.setState({  
			  AssignmentData: resp.data,  
			
			});
     }
	 else{
		   this.setState({AssignmentData:[],});
	 }
   
    });

}



	   HandleCheckbox=(id,rowsd)=>{

  const updatedArray=[...this.state.AssignmentData];
	  if(updatedArray[rowsd].isselected==="0")
	  {
		  updatedArray[rowsd].isselected = "1" ;
		   
		  
	  }
	
	 
	  else
	  {
	  updatedArray[rowsd].isselected = "0" ;
	  
      }
	  
	  this.setState({AssignmentData:updatedArray,},()=>{
	

			
	
	  }) ;
		  
		  
	  
  } 

handleSubmit = (event) => {


  let optionsVal = this.state.AssignmentData;
  let optionValues = "";
  let sep1 = "",strselect="";


/*
  if (this.state.subid=== "") {
    this.setState({errormessage: "Please Select subject",erropen: true,errortype: 'error'
    });
    window.scrollTo({ top: 0 });
    return false;
  }

  if (this.state.ts_ur_id=== "") {
    this.setState({errormessage: "Please Select Teacher",erropen: true,errortype: 'error'
    });
    window.scrollTo({ top: 0 });
    return false;
  }

  if (optionsVal.length === 0) {
    this.setState({errormessage: "Please Select Batch",erropen: true,errortype: 'error'
    });
    window.scrollTo({ top: 0 });
    return false;
  }
*/



  optionsVal.forEach(eachval => {
     if(eachval.isselected!=="0")
   {
strselect="1";
   }	
   
      optionValues += sep1+eachval.isselected + "~" + eachval.sa_id;
      sep1 = "`"; 
    
  });
  

  

 if (strselect==="") {
    this.setState({
      errormessage: "Please select any students",
      erropen: true,
      errortype: 'error'
    });
    return false;
  }

  const formData = new FormData();
  formData.append('action', 'status');
  formData.append('statuslist', optionValues);
  formData.append('userid', localStorage.getItem('MMCuserid'));


  formData.append('swa_as_id', this.state.asid);
  axios.post( Serverurl + 'ajaxassignment.php', formData)
    .then(res => {


		this.setState({errormessage: "Submitted Successfully",
      erropen: true,
      errortype: 'success',AssignmentData:[],Batcharr:[],assignarray:[],subarra:[],sylabus:'',allchecked:'',});

	
	 
    })
  
}





handleSyllabusChange = (event) => {
 
	 
  let nam = event.target.name;
  let val = event.target.value;

	  
	   this.setState({[nam]: val,}, () => {
		   
		   
if(this.state.classid!="0" & this.state.sylabus!==0)
	   {
		  
 	this.SubjectBind();
	
	
	   }
});  
}



handleErrorclose=(event)=>{
	this.setState({erropen:false,});
	
}













	 HandleAllcheckbox=()=>{
 var studArray = this.state.AssignmentData;
	 
	 const updatedArray = [...this.state.AssignmentData];
	 
	 console.log('bulkdata',updatedArray);
	 
	 this.setState({allchecked:!this.state.allchecked},() => {
	     if(this.state.allchecked===false)
		 {
			
		 var subnewRow=studArray.map((rowssub,j) => {
					 updatedArray[j].isselected = "0" ;
				 });
				
		 
				 
		  }
		 else if(this.state.allchecked===true)
			 
			 {
				
				  var subnewRow = studArray.map((rowssub, j) => {
				   updatedArray[j].isselected = "1" ;
			   });
				 
			 }
			 this.setState({AssignmentData:updatedArray,},()=>{
				 
				 console.log(this.state.AssignmentData);
			
			 });
		 
	 }); 
	 
	 
  }







AssignmentBind()
{
	axios.get(Serverurl+'ajaxassignment.php?action=getall&as_sb_id='+this.state.subid+'&as_tc_classid='+this.state.classid+'&as_syllabustype='+this.state.sylabus+'&as_branch_id='+localStorage.getItem('MMCbranchid'))
        .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						assignarray:resp.data	
							}) 
			}else{
				
				this.setState({
						assignarray:[]	
							}) 
			}

	   }).then(data => {
        let batchFromApi = this.state.assignarray.map(row => {
                          
          return {value: row.as_id, display:row.as_title}
        });
      
		
        this.setState({
          assignarray: [{value: '0', display: 'Select Assignment'}].concat(batchFromApi)
        });
      })

}


handleClickSearch = () => {   
  if (this.state.classid === 0) {
    this.setState({
      errormessage: "Please select Class",
      erropen: true,
      errortype: 'error'
    });
  } 
  else if (this.state.sylabus === 0) {
    this.setState({
      errormessage: "Please select Syllabus",
      erropen: true,
      errortype: 'error'
    });
  } 
  else if (this.state.subid === 0) {
    this.setState({
      errormessage: "Please select Subject",
      erropen: true,
      errortype: 'error'
    });
  } 
  else if (this.state.batchid === 0) {
    this.setState({
      errormessage: "Please select Batch",
      erropen: true,
      errortype: 'error'
    });
  } 
  else if (this.state.asid === 0) {
    this.setState({
      errormessage: "Please select Assignment",
      erropen: true,
      errortype: 'error'
    });
  } 
  else {
    this.GetAssignmentList();
  }
}

	render(){
		
		if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
		
		
		return(
		  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2>Assignment Submission</h2>
</div></div>




<div className="searchmaster">

<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
<ul>





  <li><p><span className="validation">*</span>Class</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.classid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.classid}
		  name="classid"
		
		
        >
		{this.state.Classarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>
	  
	  
	  
	   <li><p><span className="validation">*</span> Sylabus Type</p>
	  <Radio
        checked={this.state.sylabus === '2'}
        onChange={this.handleSyllabusChange}
        value="2"
        name="sylabus"
        inputProps={{ 'aria-label': 'B' }}
      />State<Radio
        checked={this.state.sylabus === '1'}
        onChange={this.handleSyllabusChange}
        value="1"
        name="sylabus"
        inputProps={{ 'aria-label': 'A' }}
      />CBSE
    <Radio
        checked={this.state.sylabus === '3'}
        onChange={this.handleSyllabusChange}
        value="3"
        name="sylabus"
        inputProps={{ 'aria-label': 'A' }}
      />PUC

	  
	 </li>
	  
	  {this.state.sylabus!==0 && (
	  
	  <li><p><span className="validation">*</span>Subject</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.subid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.subid}
		  name="subid"
		
		
        >
		{this.state.subarra.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>
	  )}
	  
	  
	   <li><p><span className="validation">*</span>Batch</p>
	  <p>
	  <FormControl  fullWidth size="small" >
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.batchlabel, value: this.state.batchid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.batchid}
		  name="batchid"
		
		
        >
		{this.state.Batcharr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>
	  
	  
	  <li><p><span className="validation">*</span>Assignment</p>
	  <p>
	  <FormControl  fullWidth size="small" >
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.asid}
		  name="asid"
		
		
        >
		{this.state.assignarray.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>
	  <li>
	  
	  	<p className="searchbutton">
		<Button variant="contained" onClick={this.handleClickSearch} className={useStyles.submit} endIcon={<SearchIcon />}>
        Search
      </Button>	</p>
	  </li>
	  
</ul>




</div>
<div className="batchlist">
  <Paper className={useStyles.root}>
    <TableContainer className={useStyles.container}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "20%" }}>Student Code </TableCell>
            <TableCell style={{ width: "20%" }}>Name</TableCell>
         
            <TableCell>   
			<Checkbox 
           checked={this.state.allchecked}
           onChange={()=>{this.HandleAllcheckbox()}}
            inputProps={{ 'aria-label': 'controlled' }}
         
              /> 
                                              
              </TableCell>  
          </TableRow>
        </TableHead>
        <TableBody>
          {this.state.AssignmentData.map(
            (item, index) => (
              <TableRow key={index}>
                <TableCell>{item.sr_studentcode}</TableCell>
                <TableCell>{item.sr_studentname}</TableCell>
               
               <TableCell>{item.isselected==="0" && (
<Checkbox
  
  onChange={()=>{this.HandleCheckbox(item.swa_id ,index)}}
  inputProps={{ 'aria-label': 'controlled' }}
/> 
)}{item.isselected!=="0" && (
<Checkbox
  checked
  onChange={()=>{this.HandleCheckbox(item.swa_id ,index)}}
  inputProps={{ 'aria-label': 'controlled' }}
  
/> 
)}</TableCell>

              </TableRow>
            )
          )}

          {this.state.AssignmentData.length === 0 && (
            <TableRow>
              <TableCell colSpan="4">
                <h5 className="aligncenter">No Records</h5>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>

 
  </Paper>
</div>
{this.state.AssignmentData.length !== 0 && (
<p className="aligncenter"><Button variant="standard" className="frmPrimarybtn" endIcon={<CheckRoundedIcon />} onClick={this.handleSubmit}>
	{this.state.submitbtn}
	</Button></p>
	)}
</div>


  </React.Fragment>
   
		);
		
		
	}
	
	
}

